export const SET_QUERY = "SET_QUERY";
export const SUBMIT_SEARCH = "SUBMIT_SEARCH";
